export default "__VITE_ASSET__82252b5e__"